import { render } from "./Dashboard.vue?vue&type=template&id=f2af2848&scoped=true"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=f2af2848&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2af2848"],['__file',"resources/js/modules/dashboard/components/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2af2848"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2af2848', __exports__)) {
    api.reload('f2af2848', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=f2af2848&scoped=true", () => {
    api.rerender('f2af2848', render)
  })

}


export default __exports__